const services = [
  {
    id: 1,
    title_en: 'Complete Blood Count (CBC)',
    title_ru: 'ОАК',
    title_am: 'Արյան ընդհանուր հետազոտություն',
  },
  {
    id: 2,
    title_en: 'Blood Glucose',
    title_ru: 'Глюкоза в крови',
    title_am: 'Գլյուկոզ արյան մեջ',
  },
  {
    id: 3,
    title_en: 'ALT, AST',
    title_ru: 'ALAT, ASAT',
    title_am: 'ALAT, ASAT',
  },
  {
    id: 4,
    title_en: 'Cholesterol and fractions',
    title_ru: 'Холестерин с фракциями',
    title_am: 'Խոլեստերին և ֆրակցիաներ',
  },
  {
    id: 5,
    title_en: 'Creatinine',
    title_ru: 'Креатинин',
    title_am: 'Կրեատինին',
  },
  {
    id: 6,
    title_en: 'Iron',
    title_ru: 'Железо',
    title_am: 'Երկաթ',
  },
  {
    id: 7,
    title_en: 'Ferritin',
    title_ru: 'Ферритин',
    title_am: 'Ֆերիտին',
  },
  {
    id: 8,
    title_en: 'Urea',
    title_ru: 'Мочевина',
    title_am: 'Միզանյութ',
  },
];
export default services;
